import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import {
    BaasicTable,
    EmptyState,
    TableFilter,
    BaasicButton
} from "core/components";
import { ApplicationListLayout, Content } from "core/layouts";
import { isSome } from 'core/utils';

const FacilityInventoryCalculationItemListTemplate = function({ facilityInventoryCalculationItemListViewStore }) {
    
    const { 
        tableStore, 
        routes,
        queryUtility, 
        authorization,
        refresh,
        process,
        isDone,
        editInventory
    } = facilityInventoryCalculationItemListViewStore;
    return (
        <ApplicationListLayout
            store={facilityInventoryCalculationItemListViewStore}
            authorization={authorization}
        >
            
            <Content emptyRenderer={renderEmpty(routes)}>
            <div className="row u-mar--bottom--sml">
                <div className="col col-lrg-6">
                    <TableFilter queryUtility={queryUtility}></TableFilter>
                </div>       
                    <div className="col col-lrg-6">
                        <BaasicButton
                            className="btn btn--base btn--primary u-push u-mar--left--tny"
                            label="Refresh"
                            onClick={() => { refresh() }}
                            disabled={isDone}
                        ></BaasicButton>
                        <BaasicButton
                            className="btn btn--base btn--primary u-push u-mar--left--tny"
                            label="Process"
                            onClick={() => { process() }}
                            disabled={isDone}
                        ></BaasicButton>
                        <BaasicButton
                            className="btn btn--base btn--primary u-push"
                            label="Edit Inventory"
                            onClick={() => { editInventory() }}
                        ></BaasicButton>
                    </div>   
            </div>
            <div className="card--table">
                {   
                    <BaasicTable
                        authorization={authorization}
                        tableStore={tableStore}
                        actionsComponent={renderActions}
                    />
                }
            </div>
            </Content>
        </ApplicationListLayout>
    );
};

function renderEmpty(routes) {
    return (
        <EmptyState
            title="FACILITY_INVENTORY_CALCULATION_ITEMS.LIST.EMPTY_STATE.TITLE"
            callToAction={routes.create}
        />
    );
}

FacilityInventoryCalculationItemListTemplate.propTypes = {
    facilityInventoryCalculationItemListViewStore: PropTypes.object.isRequired
};

function renderActions({ item, actions, authorization}) {
    if (!isSome(actions)) return null;

    const { onDelete, onPreview, onPreviewExtraOrBlank } = actions;
    if (!isSome(onDelete) && !isSome(onPreview) && !isSome(onPreviewExtraOrBlank)) return null;

    return (
        <td className="table__body--data right">
            <div className="table__icons">               
                {isSome(onPreview) && !item.isExtra && !item.isTypeCellBlank ? (
                    <BaasicButton
                        authorization={authorization ? authorization.read : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--edit u-icon--sml'
                        label='Edit'
                        onlyIcon={true}
                        onClick={() => onPreview(item)}>
                    </BaasicButton>
                ) : null}
                {isSome(onPreviewExtraOrBlank) && (item.isExtra || item.isTypeCellBlank) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.read : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--preview u-icon--sml'
                        label='Preview'
                        onlyIcon={true}
                        onClick={() => onPreviewExtraOrBlank(item)}>
                    </BaasicButton>
                ) : null}
                {isSome(onDelete) && item.isExtra && !item.isDone? (
                        <BaasicButton
                            authorization={authorization ? authorization.delete : null}
                            className="btn btn--icon is-delete"
                            icon='u-icon u-icon--delete u-icon--sml'
                            label='FACILITY_INVENTORY.LIST.BUTTON.DELETE'
                            onlyIcon={true}
                            onClick={() => onDelete(item)}>
                        </BaasicButton>
                    ) : null}
            </div>
        </td>
    )
}

renderActions.propTypes = {
    item: PropTypes.object,
    actions: PropTypes.object,
    authorization: PropTypes.any,
    isDone: PropTypes.bool,
    editInventory: PropTypes.func
};

export default defaultTemplate(FacilityInventoryCalculationItemListTemplate);